import { render, staticRenderFns } from "./batch-grant.vue?vue&type=template&id=4226140a&"
import script from "./batch-grant.vue?vue&type=script&lang=js&"
export * from "./batch-grant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports